import { LOCATION_CHANGE } from 'connected-react-router';
import * as H from 'history';
import { Reducer } from 'redux';
import { LocationState } from '../../../type-definitions/redux-declarations';

const initialState: LocationState = {
	previousPath: '',
	currentPath: '',
};

type Action = {
	type: string;
	payload: { location: H.Location };
};

const reducer: Reducer<LocationState, Action> = (
	state = initialState,
	action: Action
) => {
	if (action.type === LOCATION_CHANGE) {
		const currentPath = action.payload.location.pathname;
		if (state.currentPath != currentPath) {
			return {
				previousPath: state.currentPath,
				currentPath: currentPath,
			};
		}
	}
	return state;
};

export { initialState, reducer as locationReducer };
